module.exports = __webpack_public_path__ + "img/icon_file.155863e6.png";